import type { ReactNode } from 'react'

/** 虚拟行渲染：绝对定位 */
export function VirtualRow({ start, height, children, className }: {
  start: number
  height: number
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: `translateY(${start}px)`,
        height,
      }}
    >
      {children}
    </div>
  )
}
